import { PaymentStatus } from "components/ClientCardAttachment/constants"
import { httpClient } from "utils/infrastructure/httpClient"

export interface PaymentStatusData {
    paid: boolean
    status: PaymentStatus
}

export function getPaymentStatus(paymentId: string | number) {
    return httpClient.get<PaymentStatusData>(`payment/status/${paymentId}`)
}

export function getOrderPaymentStatus(orderHash: string | number) {
    return httpClient.get<PaymentStatusData>(`payment/status/order/${orderHash}`)
}
